import script from "./DetalheLicenca.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalheLicenca.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__